export default __webpack_public_path__ + "static/media/chevron-down.47a57a75.svg";